var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("baselines", { attrs: { stay_id: _vm.stay_id } }),
      _vm._v(" "),
      _c("hr"),
      _vm._v(" "),
      _c("standard-investigations-list", { attrs: { stay_id: _vm.stay_id } }),
      _vm._v(" "),
      _c("div", { staticClass: "mb-5" })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }